import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { PageLoader } from "@/components/auth/Guards";
import { ShortItem } from "@/components/video/ShortItem";

export default function ShortsPage() {
  const { request } = useProfile();
  const [params] = useSearchParams();
  const feed = useRef(null);
  const [videos, setVideos] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    request("get", "/videos", null, { params: { format: "short", limit: 50 } }).then((vs) => {
      const start = params.get("start");
      const i = vs.findIndex((v) => v.id === start);
      setVideos(i > 0 ? [...vs.slice(i), ...vs.slice(0, i)] : vs);
      setActiveId((i > 0 ? vs[i] : vs[0])?.id || null);
    }).catch(() => setVideos([]));
  }, [request, params]);

  useEffect(() => {
    if (!videos?.length) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => e.isIntersecting && setActiveId(e.target.dataset.videoId)),
      { root: feed.current, threshold: 0.6 });
    feed.current.querySelectorAll(".short-item").forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, [videos]);

  if (videos === null) return <PageLoader />;
  return (
    <div data-testid="shorts-page" className="fixed inset-x-0 top-16 bottom-[92px] md:bottom-0 z-30 bg-black">
      <Link to="/videos" data-testid="shorts-back" className="absolute left-4 top-4 z-10 grid h-9 w-9 place-items-center rounded-full bg-black/60 text-white backdrop-blur" aria-label="Back to videos"><ArrowLeft className="h-5 w-5" /></Link>
      {videos.length === 0 ? (
        <p className="grid h-full place-items-center text-sm text-slate-500">No shorts yet.</p>
      ) : (
        <div ref={feed} data-testid="shorts-feed" className="mx-auto h-full max-w-md overflow-y-scroll snap-y snap-mandatory scrollbar-none">
          {videos.map((v) => <ShortItem key={v.id} video={v} active={v.id === activeId} muted={muted} setMuted={setMuted} />)}
        </div>
      )}
    </div>
  );
}
